type Props = {
  className?: string;
  children?: React.ReactNode;
};

/**
 * Fenced code blocks from markdown (```lang). Swap for Shiki/Prism later if you want highlighting.
 */
export function CodeBlock({ className, children }: Props) {
  const match = /language-(\w+)/.exec(className || "");
  const language = match ? match[1] : "text";
  const code = String(children).replace(/\n$/, "");

  return (
    <pre className="my-4 overflow-x-auto rounded-xl border border-white/10 bg-black/50 p-4 text-sm leading-relaxed">
      <code className={`font-mono text-slate-200 language-${language}`}>{code}</code>
    </pre>
  );
}
